export default "__VITE_ASSET__BFbnzxpq__"